import { memo } from "react";
import { useSelector } from "react-redux";
import { formatDate } from "../../../services/shared";
import LocalActivityOutlinedIcon from '@mui/icons-material/LocalActivityOutlined';

export interface Ticket {
  id: string
  createdAt: string
  subject: string
  priority: string
  category: any
  content: string
  status: string
  pipelineStage: string
}


const List = (props: { openTickets: Ticket[], closedTickets: Ticket[], createNewTicket: () => void, setTicketDetails: any }) => {

  const design = useSelector((state: any) => state?.design);

  return (
    <>
      <div id='ele-76' className=" overflow-y-scroll relative h-full hide-scrollbar">
        {!!props.openTickets.length &&
          <div id='ele-77' className="text-primaryText text-xl font-bold px-2 py-4 pb-0">
            <div id='ele-78' className="pb-2 text-primaryText text-lg font-mSemiBold">
              Pending Tickets
            </div>


            <div id='ele-79' className="flex flex-col" >
              {
                props.openTickets.map((ticket, index) => {
                  return (
                    <div key={'ticket' + ticket.id} className="ele-open-tickets flex flex-col border border-solid rounded-xl p-3 mb-3 cursor-pointer bg-white"
                      onClick={(() => props.setTicketDetails(ticket))}>
                      <div className="ele-open-tickets-header flex justify-between">
                        <div className="ele-open-ticket-id text-secondaryText text-xs font-thin">{formatDate(ticket.createdAt)}・#{ticket.id}</div>
                        <div className="ele-open-ticket-status text-orange text-xs">Pending</div>
                      </div>
                      <div className="ele-open-ticket-body flex flex-col">
                        <div className="ele-open-ticket-subject text-sm font-mSemiBold mt-1 font-thin">{ticket.subject}</div>
                        <div className="ele-open-ticket-content text-xs mt-1 text-footer font-thin">{ticket.content}</div>
                      </div>

                    </div>
                  )
                })
              }
            </div>


          </div>
        }

        {!!props.closedTickets.length &&
          <div id='ele-87' className="text-primaryText text-xl font-bold px-2 p-4">
            <div id='ele-88' className="pb-2 text-primaryText text-lg font-mSemiBold">
              Resolved Tickets
            </div>


            <div id='ele-89' className="flex flex-col" >
              {
                props.closedTickets.map((ticket, index) => {
                  return (
                    <div key={'ticket' + ticket.id} className="ele-closed-tickets flex flex-col border border-solid rounded-xl p-3 mb-3 cursor-pointer bg-white"
                      onClick={(() => props.setTicketDetails(ticket))}>
                      <div className="flex justify-between ele-closed-ticket-header">
                        <div className="ele-closed-ticket-id text-secondaryText text-xs font-thin">{formatDate(ticket.createdAt)}・#{ticket.id}</div>
                        <div className="ele-closed-ticket-status text-green text-xs">Resolved</div>
                      </div>
                      <div className="ele-closed-tickets-body flex flex-col">
                        <div className="ele-closed-ticket-subject text-sm font-mSemiBold mt-1 font-thin">{ticket.subject}</div>
                        <div className="ele-closed-ticket-content text-xs mt-1 text-footer font-thin">{ticket.content}</div>
                      </div>

                    </div>
                  )
                })
              }
            </div>
          </div>
        }

      </div >

      <div
        id='ele-97'
        className="absolute bottom-4 right-0 align-middle justify-center items-center text-white rounded-lg px-6 py-2 cursor-pointer shadow-md"
        style={{ backgroundColor: design?.themeColor }}
        onClick={props.createNewTicket}
      >        
        <LocalActivityOutlinedIcon className={`!text-xl align-middle justify-center items-center`}/>
        <button id='ele-98' className="align-bottom ml-2">Create New Ticket</button>
      </div>
    </>
  );
}

export default memo(List);

